import { Component, NgZone, OnInit, Input, Inject, Optional } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { ConfigurationElement, ListConfigurationStates } from '../models/configuration.model';
import { ConfigurationService } from '../services/configuration.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogService } from '../services/dialog.service';
import { StorageService } from './../services/storage.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-configuration',
  templateUrl: './configuration.component.html',
  styleUrl: './configuration.component.css'
})

export class ConfigurationComponent implements OnInit  {

  constructor(public ngZone: NgZone, private router: Router, private route: ActivatedRoute,
              private configurationService: ConfigurationService, private dialogService: DialogService,
              private storageService: StorageService, @Optional() @Inject(MAT_DIALOG_DATA) dialogData: ConfigurationElement | null,
              @Optional() public dialogRef: MatDialogRef<ConfigurationComponent> | null, public translocoService: TranslocoService) {
    this.data = dialogData;
  }

  @Input() data: ConfigurationElement | null = null;
  @Input() inline = false;
  public titleConfiguration = "Configuración";
  public new = false;
  role: number=10;

  stateControl = new FormControl('', [Validators.required]);

  lstConfigurationStates: ListConfigurationStates[] = [];
  item: any = [];

  serial_number_Input:string="";
  desired_active_sampling_time_Input?:number=0;
  desired_active_sending_time_Input?:number=0;
  desired_state_Selected?:number=0;
  update_name_Input:string="";

  configuration: ConfigurationElement = {
    device_id: 0,
    company_id: 0,
    serial_number: '',
    desired_active_sampling_time: undefined,
    desired_active_sending_time: undefined,
    desired_state: undefined,
    update_name: ''
  }

  ngOnInit(): void {
    const data = this.data;
    if(data?.device_id){
      this.new = false
      this.titleConfiguration="Editar Configuración";

      let isLoggedIn = this.storageService.isLoggedIn();
      if (isLoggedIn) {
        this.role = this.storageService.getSessionUser()?.roleId ?? 0;
      }

      //GET
      const req=this.configurationService.getConfigurationById(data.device_id, data.company_id);
      req.subscribe({
        next: (res) => {
          this.item = res;
          if(this.item.data != null){
            this.serial_number_Input = data.serial_number;
            this.desired_active_sampling_time_Input = this.item.data.desired_active_sampling_time;
            this.desired_active_sending_time_Input = this.item.data.desired_active_sending_time;
            this.desired_state_Selected = this.item.data.desired_state;
            this.update_name_Input = this.item.data.update_name || '';
          }
        },
        error: (e) => {
          this.dialogRef?.close();
          let msg = e.error.message;
          console.error(e);
          this.msgDialog('ERROR', msg, false, 'E');
        },
      });
    }else{
      //SIN DATOS
      this.dialogRef?.close();
      let msg = "Dispositivo no indicado.";
      this.msgDialog(msg, '', true, 'O');
    }

    this.lstConfigurationStates=this.configurationService.getConfigurationStatesList();

  }

  onGuardarItm(){
    if (!this.data) return;
    let msg:string="";
     //UPDATE
    this.configuration = {
      device_id: this.data.device_id,
      company_id: this.data.company_id,
      serial_number: '',
      desired_active_sampling_time: this.desired_active_sampling_time_Input,
      desired_active_sending_time: this.desired_active_sending_time_Input,
      desired_state: this.desired_state_Selected,
      ...(this.isSuperAdmin ? { update_name: this.update_name_Input } : {}),
    }
    this.configurationService.updateConfiguration(this.data.device_id, this.configuration, this.data.company_id)
    .subscribe({
      next: (res) => {
        msg = res.message;
        console.log(msg);
        this.msgDialog(msg, '', true, 'O');
      },
      error: (e) => {
        msg = e.error.message;
        console.error(e);
        this.msgDialog('ERROR', msg, false, 'E');
      },
    });
  }

  get isSuperAdmin(): boolean {
    return this.role === 1;
  }

  msgDialog(msgShow:string, msg2Show:string, isOK:boolean, type:string){
    this.dialogService.confirmDialog({
      title: this.translocoService.translate('configuration.msgTitle'),
      message: msgShow,
      message2: msg2Show,
      confirmText: 'OK',
      cancelText: '',
      showConfirmBox: false,
      dialogType: type,
    })
    .subscribe((yes) => {
      if (isOK) {
        setTimeout(() => {
          console.log('Si guardar configuracion.');
          this.dialogRef?.close();
        }, 1000);
      }
    });
  }

}
